import * as yup from 'yup'

export class SettingsBondPolicyDto {
  bondThreshold?: number = undefined
  nextPolicyNumber?: number = undefined
  bondBlockQuantityAlertNotificationEmail?: number = undefined
}

export const settingsBondPolicyValidationSchema = yup.object({
  bondThreshold: yup
    .number()
    .min(0, 'Bond Threshold cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Bond Threshold cannot be more than $999,999,999,999.99.')
    .required('Bond Threshold is required.'),
  bondBlockQuantityAlertNotificationEmail: yup.number().min(0).required('Bond Block Quantity is required.')
})
